/* eslint-disable jsx-a11y/anchor-is-valid */

interface INoAgendaCard {
  openModal: (val: boolean) => void;
}

export const NoAgendaCard = ({ openModal }: INoAgendaCard) => {
  return (
    <div className="agenda-wrap bg-white p-3 rounded-4">
      <div className="py-3">
        <h4 className="text-muted text-center">
          Este profissional ainda não disponibilizou sua agenda.
        </h4>
        <p>Tente em outro local de atendimento ou</p>
        <a
          className="btn btn-primary"
          onClick={() => {
            console.log("open");
            openModal(true);
          }}
        >
          Solicite uma Consulta
        </a>
      </div>
    </div>
  );
};
